import React from "react";
import { Chart } from "react-google-charts";
import PropTypes from "prop-types";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import { addNotesToData, chartToSeries } from "./chartHelpers";
import "./ChartsContainer.scss";

function ChartsContainer(props) {
  const { 
    visible, 
    charts, 
    selectValue, 
    onChartTypeChange, 
    selectedAverage, 
    setSelectedAverage, 
    groupPages, 
    setGroupPages, 
    selectedGroups, 
    notes, 
    showNotes,
    periodType 
  } = { ...props };
  const options = {
    height: 300,
    legend: { position: "top", maxLines: 3 },
    tooltip: { isHtml: true, trigger: "visible" },
    legend: { position: "right" }
  };

  if (!visible) return null;
  return (
    <div className="charts">
      {charts?.map((item, index) => {
        const { id, chartType, data, width, height, dataType } = {
          ...item,
        };
        if (!data || data?.length === 0 || data?.length === 1) return null;
        if(dataType === 'cls' || dataType === 'fcp' || dataType === 'fid' || dataType === 'lcp' || dataType === 'inp' || dataType === 'ttfb') {
          data.forEach((element) => {
            if(selectedAverage[dataType] && element.length === 9 && !element[7]) {
              element[7] = 0;
            }
          });
        }

        const {data: finalData, maxValue, barWidth} = showNotes? 
          addNotesToData(data, notes, item, chartType, periodType): { data };
        
        return (
          <div className="chart-container" key={id || index}>
            {(dataType === "clicks" || dataType === "impressions") && (
              <div className="select-chart-type-container">
                <FormControl className="chart-select">
                  <InputLabel>Tipo de gráfico</InputLabel>
                  <Select
                    native
                    id="grouped-native-select"
                    label="Tipo de gráfico"
                    onChange={(event) => onChartTypeChange(event, dataType)}
                    size="small"
                    value={selectValue[dataType]}
                  >
                    <option value="AreaChart">Acumulado</option>
                    <option value="LineChart">Simples</option>
                  </Select>
                </FormControl>
              </div>
            )}
            {
              (dataType === "fcp" || dataType === "lcp" || dataType === "fid" || dataType === "cls" || dataType === "inp" || dataType === "ttfb") && 
              <div className="select-chart-wv">
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>Porcentagem de páginas</Typography>
                  <Switch 
                    checked={selectedAverage[dataType]}
                    onChange={(e) => setSelectedAverage({...selectedAverage, ...{[dataType]: e.target.checked} })}
                  />
                  <Typography>Média</Typography>
                </Stack>
                {
                  selectedAverage[dataType] !== undefined && !selectedAverage[dataType] &&
                  <FormControl>
                    <InputLabel>Tipo de gráfico</InputLabel>
                    <Select
                      native
                      id="grouped-native-select"
                      label="Tipo de gráfico"
                      onChange={(event) => setGroupPages({...groupPages, ...{[dataType]: event.target.value} })}
                      size="small"
                      value={groupPages[dataType]}
                    >
                      {
                      selectedGroups?.map((group) => {
                        return (
                          <option value={group?.id} key={group?.id}>{`${group.id} - ${group?.name}`}</option>
                        )
                      })}
                    </Select>
                </FormControl>
                }
                
              </div>              
            }
            
            <Chart
              chartType={showNotes? "ComboChart": chartType}
              width={width ? width : "100%"}
              height={height ? height : "400px"}
              data={finalData}
              options={{
                ...options,
                ...item.options,
                seriesType: showNotes? chartToSeries[chartType]: undefined,
                title: item.options?.title || dataType?.toUpperCase(),
                vAxis: { minValue: 0, title: "Dados", viewWindow: { max: maxValue } },
                hAxis: { title: "Datas" },
                legend: { position: "top" },
                bar: { groupWidth: barWidth }
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default ChartsContainer;

ChartsContainer.defaultProps = {
  visible: false,
  config: [],
  selectValue: {},
  onChartTypeChange: null,
};

ChartsContainer.propTypes = {
  visible: PropTypes.bool,
  config: PropTypes.array,
  selectValue: PropTypes.object,
  onChartTypeChange: PropTypes.func,
};
